import { useCallback, useState } from 'react'
import { format, startOfDay, endOfDay } from 'date-fns'

import { FILTER_MODES, FILTER_OPERATORS, FILTER_TYPES } from './../table.constants'

export const useTableFilters = (
  onSearch,
  tableColumns,
  pagination,
  setGlobalFilter,
  onColumnFilter,
  setFilter,
  setAllFilters,
  filterMode
) => {
  const [shouldClearFilters, setShouldClearFilters] = useState(false)

  const handleColumnFilter = useCallback(
    (columnId, value) => {
      switch (filterMode) {
        case FILTER_MODES.CLIENT_SIDE:
          setFilter(columnId, value)
          break
        case FILTER_MODES.SERVER_SIDE:
          const columnInfo = tableColumns.find((item) => item.id === columnId)
          pagination?.setPage?.(0)
          let newColumns = {}
          if (columnInfo.filter === FILTER_TYPES.range) {
            onColumnFilter((prevValue) => {
              if (!value) {
                newColumns = {
                  ...prevValue,
                  [columnInfo.serverSideKey]: {},
                }
              } else {
                newColumns = {
                  ...prevValue,
                  [columnInfo.serverSideKey]: [
                    {
                      operator: FILTER_OPERATORS.GREATER_THAN_EQUAL,
                      value: value[0] && format(startOfDay(value[0]), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
                    },
                    {
                      operator: FILTER_OPERATORS.LESS_THAN_EQUAL,
                      value: value[1] && format(endOfDay(value[1]), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
                    },
                  ],
                }
              }
              Object.keys(newColumns).forEach((key) => {
                if (
                  (newColumns[key]?.value === null || newColumns[key]?.value === undefined) &&
                  !newColumns[key]?.[0]?.value &&
                  !newColumns[key]?.[1]?.value
                ) {
                  delete newColumns[key]
                }
              })

              return newColumns
            })
          } else if (columnInfo.filter === FILTER_TYPES.array) {
            onColumnFilter((prevValue) => {
              if (!value) {
                newColumns = {
                  ...prevValue,
                  [columnInfo.serverSideKey]: {},
                }
              } else {
                newColumns = {
                  ...prevValue,
                  [columnInfo.serverSideKey]: {
                    operator: columnInfo.serverSideFilterOperator,
                    value: [value],
                  },
                }
              }

              Object.keys(newColumns).forEach((key) => {
                if (
                  (newColumns[key]?.value === null || newColumns[key]?.value === undefined) &&
                  !newColumns[key]?.[0]?.value &&
                  !newColumns[key]?.[1]?.value
                ) {
                  delete newColumns[key]
                }
              })

              return newColumns
            })
          } else {
            onColumnFilter((prevValue) => {
              if (!value && value !== false) {
                newColumns = {
                  ...prevValue,
                  [columnInfo.serverSideKey]: {},
                }
              } else {
                newColumns = {
                  ...prevValue,
                  [columnInfo.serverSideKey]: {
                    operator: columnInfo.serverSideFilterOperator,
                    value,
                  },
                }
              }
              Object.keys(newColumns).forEach((key) => {
                if (
                  (newColumns[key]?.value === null || newColumns[key]?.value === undefined) &&
                  !newColumns[key]?.[0]?.value &&
                  !newColumns[key]?.[1]?.value
                ) {
                  delete newColumns[key]
                }
              })

              return newColumns
            })
          }
          break
        default:
          break
      }
    },
    [filterMode, onColumnFilter, setFilter, tableColumns, pagination]
  )

  const clearFilters = useCallback(() => {
    if (filterMode === FILTER_MODES.CLIENT_SIDE) {
      setAllFilters([])
    } else {
      setShouldClearFilters(true)
      onColumnFilter({})
    }
  }, [filterMode, setAllFilters, onColumnFilter])

  const handleGlobalFilter = useCallback(
    (value) => {
      switch (filterMode) {
        case FILTER_MODES.CLIENT_SIDE:
          setGlobalFilter(value)
          break
        case FILTER_MODES.SERVER_SIDE:
          onSearch(value)
          break
        default:
          break
      }
    },
    [filterMode, onSearch, setGlobalFilter]
  )

  return {
    handleColumnFilter,
    clearFilters,
    handleGlobalFilter,
    shouldClearFilters,
    setShouldClearFilters,
  }
}
